export const MAIN_SITE_LINK = 'https://www.zoopla.co.uk';

// For Google Analytics
export const GA_CUSTOM_EVENT = 'GAEvent';
export const GA_CUSTOM_CATEGORY = 'discover';
